import React from "react";
import { Field, ErrorMessage } from "formik";
import { useMembershipRegistrationContext } from "../../context/MembershipRegistrationContext";
import PhoneNumberFieldComponent from "../common/PhoneNumberFieldComponent";

export default function ProfessionalDetailsComponent() {
  const { countries } = useMembershipRegistrationContext();
  return (
    <div
      className="col-12 my-0 rounded-3 p-4"
      style={{
        border: "1px solid #e9ecef",
        backgroundColor: "#fff",
      }}
    >
      <h4 className="fw-bold mb-4">Professional Details</h4>
      {/* Info Box */}
      <div className="alert alert-info shadow-sm">
        <h6 className="fw-bold mb-3">Professional Details Entry Guidelines</h6>

        <p className="mb-2">
          <strong>Industry: </strong>
          The industry you are working in.
        </p>
        <em>Examples:</em>
        <ul className="mb-0">
          <li>Healthcare</li>
          <li>Construction</li>
          <li>Telecommunications</li>
        </ul>

        <p className="my-2">
          <strong>Profession: </strong>
          The profession you are working in.
        </p>
        <em>Examples:</em>
        <ul className="mb-0">
          <li>Doctor</li>
          <li>Engineer</li>
          <li>Manager</li>
        </ul>

        <p className="my-2">
          <strong>Designation: </strong>
          The position you are holding.
        </p>
        <em>Examples:</em>
        <ul className="mb-0">
          <li>Consultant Surgeon</li>
          <li>Consultant Construction Engineer</li>
          <li>Regional Marketing Manager</li>
        </ul>

        <br />

        <h6 className="fw-bold mb-3">
          You can skip this section if you do not wish to enter the details.
        </h6>
      </div>

      {/* Industry */}
      <div className="col-12 mb-3">
        <label className="form-label">Industry</label>
        <Field type="text" name="industry" className="form-control" />
        <ErrorMessage name="industry" component="div" className="text-danger" />
      </div>

      {/* Profession */}
      <div className="col-12 mb-3">
        <label className="form-label">Profession</label>
        <Field type="text" name="profession" className="form-control" />
        <ErrorMessage
          name="profession"
          component="div"
          className="text-danger"
        />
      </div>

      {/* Designation */}
      <div className="col-12 mb-3">
        <label className="form-label">Designation</label>
        <Field type="text" name="designation" className="form-control" />
        <ErrorMessage
          name="designation"
          component="div"
          className="text-danger"
        />
      </div>

      {/* Employer Name */}
      <div className="col-12 mb-3">
        <label className="form-label">Employer Name</label>
        <Field type="text" name="employerName" className="form-control" />
      </div>

      {/* Employer Address */}
      <div className="col-12 mb-3">
        <label className="form-label">Employer Address</label>
        <Field
          as="textarea"
          name="employerAddress"
          rows={2}
          className="form-control"
        />
      </div>

      {/* Office Number */}
      <PhoneNumberFieldComponent
        label="Office Number"
        countryCodeName="officeNumberCountryCode"
        numberName="officeNumber"
        placeholder="7XXXXXXXX"
        required={false}
        countries={countries}
      />
    </div>
  );
}
